import { useTranslation } from "react-i18next"
import styles from './DonatedScreen.module.scss'

export const DonatedScreen = () => {
    const { t } = useTranslation()
    return <div className={styles.wrapper}>
        <img className={styles.img} src="/assets/not-claim/donate.png"></img>
        <div className={styles.thanks}>{t('rewards.thanksForDonate')}</div>
    </div>
}